export default "__VITE_ASSET__ad86a680__"